export class AccountFieldParameter {
  activeDirectories: string[] | undefined;
}
